import { formatCurrency } from '@parlaygames/currency';

/**
 * @param {number} value
 * @param {string} currency
 * @param {import('@parlaygames/site-api').SiteApiCurrencies} [meta]
 */
export const getFormattedCurrency = (value, currency, meta) => {
    if (value > 0) {
        if (meta) {
            return formatCurrency(value, meta);
        }

        return `${currency} ${value}`;
    }
    return '';
};
